import { Button, Dialog, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { StatefulButton } from "../../components/ui/muiButtons";

type DeactivateRecipientWarningModalProps = {
  open: boolean;
  onCancel: () => void;
  onDeactivate: () => void;
};

const DeactivateRecipientWarningModal = ({ open, onCancel, onDeactivate }: DeactivateRecipientWarningModalProps) => {
  const {
    control,
    formState: { isValid },
    handleSubmit,
    reset,
  } = useForm<{
    deactivateField: string;
  }>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      deactivateField: "",
    },
  });

  const handleCancel = () => {
    reset();
    onCancel();
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Delete Recipient</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete this recipient? This action cannot be undone.</Typography>
        <Typography sx={{ marginTop: "16px" }}>Please type "delete" to confirm</Typography>
        <form onSubmit={handleSubmit(onDeactivate)}>
          <Controller
            name="deactivateField"
            control={control}
            rules={{
              required: true,
              validate: (value) => value.toLocaleLowerCase() === "delete",
            }}
            render={({ field }) => (
              <TextField
                fullWidth
                variant="standard"
                margin="normal"
                {...field}
                aria-label="Type delete to delete the recipient"
              />
            )}
          />
        </form>

        <Grid container spacing={2} sx={{ justifyContent: "flex-end", marginTop: 1 }}>
          <Grid>
            <Button variant="text" onClick={handleCancel}>
              Cancel
            </Button>
          </Grid>
          <Grid>
            <StatefulButton
              loading={false}
              disabled={!isValid}
              onClick={onDeactivate}
              role="button"
              aria-label="Confirm recipient deletion"
            >
              Delete
            </StatefulButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export { DeactivateRecipientWarningModal };
